// Site-wide King of Cards scripts (loaded on every page from theme.liquid)

// CHANGE: Prize draw – "Sign up now" button opens the Klaviyo pop-up form.
// The button links to the Prize Draw page. If Klaviyo hasn't loaded
// (e.g. an ad blocker), the link simply opens that page instead.
(() => {
  const PRIZE_DRAW_FORM_ID = 'QRAdbq'; // CHANGE: your Klaviyo form ID

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('a.btn[href*="/pages/prize-draw"]');
    if (!trigger) return;

    // Links inside the Klaviyo form (e.g. Terms & Conditions) work as normal
    if (trigger.closest('[class*="kl-private-reset-css"]')) return;

    // FIX: only check Klaviyo has loaded; the openForm check was too strict
    if (!window._klOnsite) return; // Klaviyo not loaded – fall back to the page
    const klaviyo = window._klOnsite;

    e.preventDefault();
    klaviyo.push(['openForm', PRIZE_DRAW_FORM_ID]);
  });
})();

// CHANGE: Prize draw – open the Klaviyo pop-up automatically when the page
// is opened with #enter-draw in the link (used by email buttons).
(() => {
  if (window.location.hash !== '#enter-draw') return;
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'QRAdbq']);
})();